import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverFilterEntity } from '../../domain/entities/DriverFilterEntity'
export class DriverFilterModel extends DriverFilterEntity {
  userId?: string
  regionId?: number
  vehicleId?: number
  vehicleTemplateId?: number
  driverTeamId?: number
  createdAtFrom?: string
  createdAtTo?: string
  constructor(dataDto: DriverFilterEntity) {
    super()
    mapEntityProperties<DriverFilterModel>(this, dataDto, {
      exclude: ['user', 'region', 'vehicleTemplate', 'driverTeam', 'driver'],
      map: {
        userId: dataDto.user?.id,
        regionId: dataDto.region?.id,
        regionIds: [dataDto.region?.id],
        vehicleTemplateId: dataDto.vehicleTemplate?.id,
        driverTeamId: dataDto.driverTeam?.id,
        searchWord: dataDto.searchWord,
        id: dataDto.driver?.id,
        createdAtFrom: dataDto.date?.[0],
        createdAtTo: dataDto.date?.[1]
      }
    })
  }
}
